import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./modeOfPayment.module.scss";
import { Typography, Box, Card } from "@mui/material";
import { CommonButton, HcccCard } from "../StyledComponents/StyledFields";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../toast/toastError";
import toast from "react-hot-toast";
import SuccessComponent from "../../volunteerRegistration/successComponent/successComponent";
import { ClipLoader } from "react-spinners";
import { donationTypesProps } from "../../../infrastructure/GlobalContextProvider";
import PayPalComponent from "./payPal/payPal";
import ErrorPopup from "../ErrorPopup";
import constants from "../../../config/constants.json";
import { PayPalPageImplementation } from "./payPal/paypalPageImplementation";
import { BeatLoader, BounceLoader } from 'react-spinners';

interface ModeofPaymentsProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedPaymentMode?: React.Dispatch<React.SetStateAction<string>>;
  creditpaymentFunction?: () => Promise<void>;
  setButtonDisable?: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedPaymentType?: React.Dispatch<React.SetStateAction<string | null>>;
  setShowSuccess?: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick?: () => Promise<void>;
  amount?: number;
  donationPurpose?: string;
  unregFormData?: any;
  payPalAddToCart?: any
  buttonDisable?: boolean;
  itemsList?: any
  setOpenPaymentDialog?: React.Dispatch<React.SetStateAction<boolean>>;
  setDialogLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  handleSave?: (paymentName: string, paymentId: number) => void;
  triggerPaymentmethod?: any;
}

const DevoteeModeOfPayment = React.memo((props: ModeofPaymentsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [itemsList, setItemList] = useState<any[]>([]);
  const [paymentMode, setPaymentMode] = useState<string | null>(null);
  const [showSuccessComponent, setShowSuccessComponent] =
    useState<boolean>(false);
  const [receiptID, setReceiptID] = useState<string>("");
  const [userID, setUserID] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [paymentModeLoading, setPaymentModeLoading] = useState(true);
  const [modeOfPayment, setModeOfPayment] = useState<number | null>(null);
  const [donationTypes, setDonationTypes] = useState<donationTypesProps[]>([]);
  const navigate = useNavigate();
  const directPaymentModes = ["manual receipt", "cash", "coin"];
  const [showPayPal, setShowPaypal] = useState<boolean>(false);
  useEffect(() => {
    setShowPaypal(false); // Whenever props.amount changes, hide the PayPal component
  }, [props.amount]);
  const onlyManagerPaymentModes = [
    "cash",
    "coin",
    "check",
    "deposit",
    "manual receipt",
    "direct deposit",
    "stock",
    "abharana",
    "zelle",
    // "paypal"
  ];

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      const cartItemObjects = JSON.parse(storedCartItems);
      setItemList(cartItemObjects);
    }
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.donationTypes,
      includeToken: true,
    })
      .then((res) => {
        // Assuming res.data is an array of payment methods
        const modifiedData = res.data.map((item: donationTypesProps) => {
          // Your logic to determine if the payment method is manager only
          // This is just an example, you'll need to replace it with your actual logic
          const isManagerOnly = determineIfManagerOnly(item); // Implement this function based on your criteria

          return {
            ...item,
            managerOnly: isManagerOnly,
          };
        });
        setDonationTypes(modifiedData);
        setPaymentModeLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // function to determine if a payment method is manager only
  function determineIfManagerOnly(item: donationTypesProps) {
    return onlyManagerPaymentModes.includes(item.name.toLowerCase());
  }

  // Function to decide which icon to use based on the payment method's name
  const getPaymentMethodIcon = (methodName: string) => {
    switch (methodName.toLowerCase()) {
      case "paypal":
        return "/images/PayPal.svg";
      case "zelle":
        return "/images/Zelle.svg";
      case "coin":
        return "/images/coins.png";
      case "cash":
        return "/images/cash.png";
      case "check":
        return "/images/check.png";
      case "manual receipt":
        return "/images/manualrecepi.svg"; // Assuming you have an icon for manual receipts
      case "direct deposit":
        return "/images/directDeposit.png";
      case "gpay":
        return "/images/GPay.svg";
      case "stock":
        return "/images/Stock.svg";
      case "credit card":
        return "/images/CreditCard.svg";
      // Add cases for other payment methods as necessary
      default:
        return "/images/defaultIcon.svg"; // Default icon if no match is found
    }
  };

  const handleCreditClick = (paymentType: string, modeOfPayment: number) => {
    // if(authService.isAuthenticated()) {
    //    navigate('/creditPayment');
    // } else {
    //    if(isNil(props.creditpaymentFunction) || !isFunction(props.creditpaymentFunction)) {

    //       props.setSelectedPaymentMode?.("credit card");
    //    } else {
    //       props.creditpaymentFunction();
    //    }
    // }
    setModeOfPayment(modeOfPayment);
    setSelectedPaymentMode(paymentType);
    props.setSelectedPaymentType?.(paymentType);
    props.setButtonDisable?.(false);
  };

  useEffect(() => {
    props?.buttonDisable && setSelectedPaymentMode("")
  }, [props?.buttonDisable])


  const onClickCashAndCoinPayment = () => {
    setLoading(true);
    const reqBody = {
      items: itemsList,
      modeOfPayment: modeOfPayment,
    };

    apiRequest({
      method: "POST",
      endpoint: apiPath.cartPayment,
      body: JSON.stringify(reqBody),
      includeToken: true
    })
      .then((res) => {
        console.log(res);
        props.setShowSuccess?.(true);
        setShowSuccessComponent(true);
        setReceiptID(res.data.receiptId);
        setUserID(res.data.userId);
        sessionStorage.removeItem("cartItems");
        sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
        navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
        setLoading(false);
        // toast.success('Data Saved Successfully!');
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
        setLoading(false);
      });
  };

  // Define a function to render the payment button if necessary
  const renderPaymentButton = () => {
    if (directPaymentModes.includes(selectedPaymentMode)) {
      return (
        <CommonButton
          onClick={onClickCashAndCoinPayment}
          sx={{ marginTop: "10px" }}
          disabled={loading}
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Make Payment"
          )}
        </CommonButton>
      );
    }
    return null; // Do not render button for other payment modes
  };

  function determineCardStyle(paymentName: string): string {

    // Example function to determine CSS class based on the selected payment mode
    // Implement according to your styling logic
    return selectedPaymentMode === paymentName.toLowerCase()
      ? styles.selectedImageStyles
      : styles.paymentImagesStylesDeafult
  }


  function handlePaymentMethodClick(
    paymentName: string,
    paymentId: number
  ): void {
    // Explicitly check for all conditions
    if (paymentName === "Zelle" || paymentName === "Abharana") {
      console.log(paymentName, "is either Zelle or Abharana");
      // Your logic here
      props.setButtonDisable?.(true);
      setSelectedPaymentMode(paymentName.toLowerCase());
    } else if (paymentName === "PayPal") {
      console.log(paymentName, "is PayPal");
      props.setButtonDisable?.(true);
      setSelectedPaymentMode(paymentName.toLowerCase());
      setShowPaypal(true);
      props.setSelectedPaymentType?.(paymentName.toLowerCase());
    } else {
      console.log(paymentName, "is some other payment method");
      setSelectedPaymentMode(paymentName.toLowerCase());
      setModeOfPayment(paymentId);
      props.setSelectedPaymentType?.(paymentName.toLowerCase());
      props.setButtonDisable?.(false);
      setShowPaypal(false);
    }
  }

  const handleClick = (paymentName: string, paymentId: number) => {
    if (props?.handleSave && paymentName === "PayPal") {
      props?.handleSave(paymentName, paymentId);
    }else {
      handlePaymentMethodClick(paymentName, paymentId)
    }
  }

  useEffect(() => {
    const {paymentName, paymentId} = props?.triggerPaymentmethod || {};
    if (paymentName && paymentId) {
      handlePaymentMethodClick(paymentName, paymentId)
    }
  }, [props?.triggerPaymentmethod])

  useEffect(() => {
    if(showPayPal) {
      handlePaypal();
    }
  }, [props.itemsList])

  const handlePaypal = () => {
    if (typeof props?.amount !== "undefined" && (isNaN(props.amount) || props.amount <= 0) || props.donationPurpose === "") {
      return <div style={{ color: "red" }}>Please enter valid amount</div>
    }
    else {
      return <PayPalPageImplementation itemsList={props.itemsList} showPayPal={showPayPal} payPalAddToCart={props.payPalAddToCart} setIsOpen={props.setIsOpen} unregFormData={props.unregFormData} amount={props.amount} purpose={props.donationPurpose} setOpenPaymentDialog={props.setOpenPaymentDialog} setDialogLoading={props.setDialogLoading} setPaymentModeLoading={setPaymentModeLoading}/>
    }
  }

  const paymentModesComponent = () => {
    return (
      <Box className={styles.ModeofPaymentConatiner}>
        <Typography className={styles.paymentheading}>
          Mode of Payment
        </Typography>
        <Box className={styles.devoteePaymentImages}>
          {donationTypes
            .filter(
              (item) =>
                !item.managerOnly
            )
            .map((item) => (
              <HcccCard key={item.id} className={determineCardStyle(item.name)}>
                <Box
                  onClick={() => handleClick(item.name, item.id)}
                >
                  <img src={getPaymentMethodIcon(item.name)} alt="" />
                  <Typography className={styles.typoGraphy}>{item.name}</Typography>
                </Box>
              </HcccCard>
            ))}
          {/* <PayPalComponent amount={props.amount} purposeOfDonation={props.donationPurpose} />  */}
        </Box>
        {showPayPal ? handlePaypal() : ""}
      </Box>
    );
  };

  const paymentTypeContainer = () => {
    return (
      <Box className={styles.ModeofPaymentConatiner}>
        <Typography className={styles.paymentheading}>
          Mode of Payment
        </Typography>
        <Box className={styles.paymentImages}>
          <HcccCard
            className={
              selectedPaymentMode === "paypal"
                ? styles.selectedImageStyles
                : styles.paymentImagesStylesDeafult
            }
          >
            <Box
              sx={{ margin: "16px 0px 0px 10px" }}
              onClick={() => handleCreditClick("paypal", 33)}
            >
              <img src="/images/PayPal.svg" />
            </Box>
          </HcccCard>
          <HcccCard className={styles.paymentImagesStyles}>
            <Box sx={{ margin: "5px 0px 0px 15px" }}>
              <img src="/images/GPay.svg" />
            </Box>
          </HcccCard>
          <HcccCard className={styles.paymentImagesStyles}>
            <Box sx={{ margin: "10px 0px 0px 10px" }}>
              <img src="/images/ApplePay.svg" />
            </Box>
          </HcccCard>

          <HcccCard className={styles.paymentImagesStyles}>
            <Box sx={{ margin: "16px 0px 0px 8px" }}>
              <img src="/images/Venmo.svg" />
            </Box>
          </HcccCard>
          <HcccCard className={styles.paymentImagesStyles}>
            <Box sx={{ margin: "10px 0px 0px 20px" }}>
              <img src="/images/Zelle.svg" />
            </Box>
          </HcccCard>
          <HcccCard
            className={
              selectedPaymentMode === "credit card"
                ? styles.selectedImageStyles
                : styles.paymentImagesStylesDeafult
            }
          >
            <Box
              sx={{ margin: "11px 0px 0px 15px" }}
              onClick={() => handleCreditClick("credit card", 20)}
            >
              <img src="/images/CreditCard.svg" />
            </Box>
          </HcccCard>
        </Box>
        {getUserSelectedRole()?.toLowerCase() !== "manager" ? (
          ""
        ) : (
          <Box sx={{ marginTop: "16px" }}>
            <Box className={styles.paymentImages}>
              <HcccCard
                className={
                  selectedPaymentMode === "coin"
                    ? styles.selectedImageStyles
                    : styles.paymentImagesStylesDeafult
                }
              >
                <Box
                  sx={{ margin: "13px 0px 3px 20px" }}
                  onClick={() => handleCreditClick("coin", 31)}
                >
                  <img src="/images/coins.png" style={{ height: "16px" }} />
                  <Typography className={styles.typoGraphy}>Coins</Typography>
                </Box>
              </HcccCard>
              <HcccCard
                className={
                  selectedPaymentMode === "cash"
                    ? styles.selectedImageStyles
                    : styles.paymentImagesStylesDeafult
                }
              >
                <Box
                  sx={{ margin: "8px 0px 0px 20px" }}
                  onClick={() => handleCreditClick("cash", 26)}
                >
                  <div
                    style={{
                      paddingBottom: "3px",
                      width: "26px",
                      height: "20px",
                    }}
                  >
                    <img src="/images/cash.png" style={{ height: "20px" }} />
                  </div>
                  <Typography className={styles.typoGraphy}>Cash</Typography>
                </Box>
              </HcccCard>
              <HcccCard
                className={
                  selectedPaymentMode === "check"
                    ? styles.selectedImageStyles
                    : styles.paymentImagesStylesDeafult
                }
              >
                <Box
                  sx={{ margin: "6px 0px 0px 18px" }}
                  onClick={() => handleCreditClick("check", 5)}
                >
                  <div
                    style={{
                      paddingBottom: "3px",
                      width: "26px",
                      height: "24px",
                    }}
                  >
                    <img src="/images/check.png" />
                  </div>

                  <Typography className={styles.typoGraphy}>Check</Typography>
                </Box>
              </HcccCard>
              <HcccCard className={styles.paymentImagesStyles}>
                <Box sx={{ margin: "6px 0px 0px 20px" }}>
                  <img src="/images/directDeposit.png" />
                  <Typography className={styles.typoGraphy}>Deposit</Typography>
                </Box>
              </HcccCard>
              <HcccCard
                className={
                  selectedPaymentMode === "manual receipt"
                    ? styles.selectedImageStyles
                    : styles.paymentImagesStylesDeafult
                }
              >
                <Box
                  sx={{ margin: "8px 0px 0px 20px" }}
                  onClick={() => handleCreditClick("manual receipt", 30)}
                >
                  <div
                    style={{
                      paddingBottom: "2px",
                      marginTop: "2px",
                      width: "10px",
                      height: "10px",
                    }}
                  >
                    <img src="/images/manualrecepi.svg" style={{ height: "28px", width: "28px" }} />
                  </div>
                  <Typography className={styles.typoGraphy} style={{ fontSize: "8px", marginTop: "12px" }} >
                    Manual Receipt
                  </Typography>
                </Box>
              </HcccCard>
              <HcccCard className={styles.paymentImagesStyles}>
                <Box sx={{ margin: "15px 0px 0px 20px" }}>
                  <img src="/images/Stock.svg" />
                  <Typography
                    className={styles.typoGraphy}
                    sx={{ color: "#003087" }}
                  >
                    Stock
                  </Typography>
                </Box>
              </HcccCard>
            </Box>
            {/* <CommonButton sx={{ margin: '16px 0' }}>Make Payment</CommonButton> */}
            {renderPaymentButton()}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <>
      {/* {paymentTypeContainer()} */}
      {paymentModeLoading ?
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <BounceLoader color="#22A699" loading={paymentModeLoading} size={45} />
          <span
            style={{
              marginLeft: "8px",
              fontSize: "15px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Please wait...
          </span>
        </div> : <>{paymentModesComponent()}</>}
    </>
  );
});

export default DevoteeModeOfPayment;
